import { createSelector } from "reselect";

const getForms = state => state.caseForms.caseFormsList;

export const caseHasForm = formCode => {
  return createSelector(
    [getForms],
    forms => forms.some(f => f.formCode && f.formCode === formCode)
  );
};